import React, { useContext } from 'react'
import { PluginContext } from '@flamingo_tech/funkgo'

import styles from './PageHeader.module.css'
import cx from '../../../utils/className'

const PageHeader = props => {
  const plugin = useContext(PluginContext)

  if (!props.title || props.hide) {
    return null
  }

  if (props.isDesktop) {
    return <div className={styles.pcTitle}>{props.title}</div>
  }

  const handleClick = () => {
    props.onHistoryBack()
  }


  return (
    <header className={cx(styles.wrapper, props.className)}>
      <button
        type="button"
        className={styles.iconLeft}
        onClick={handleClick}
        aria-label={plugin.$i18n.transl('common.back')}
      />
      <div className={styles.title}>{props.title}</div>
      {props.renderIcons && props.renderIcons()}
    </header>
  )
}

export default PageHeader